import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { InlineSVGModule } from 'ng-inline-svg';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@tripointe/tripointe-cms/material';
import { RouterModule } from '@angular/router';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { NgxMaskModule } from 'ngx-mask';

// components
import { IconComponent } from './icon/icon.component';
import { ControlWrapperComponent } from './control-wrapper/control-wrapper.component';
import { ErrorContentComponent } from './error-content/error-content.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { ShowHidePasswordComponent } from './show-hide-password/show-hide-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ModalTemplateComponent } from './modal-template/modal-template.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { PaginatorTitleComponent } from './paginator-title/paginator-title.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ImageCropperDialogComponent } from './image-cropper-dialog/image-cropper-dialog.component';
import { NotificationsAssignmentComponent } from './notifications-assignment/notifications-assignment.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { ExportWidgetComponent } from './export-widget/export-widget.component';
import { AlertComponent } from './alert/alert.component';
import { GroupedAutocompleteComponent } from './grouped-autocomplete/grouped-autocomplete.component';
import { SwipeHintComponent } from './swipe-hint/swipe-hint.component';
import { CheckListComponent } from './check-list/check-list.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { DeleteItemComponent } from './delete-item/delete-item.component';

// directives
import { TooltipDirective } from './tooltip/tooltip.directive';
import { TrimOnBlurDirective } from './trim-on-blur/trim-on-blur.directive';
import { IsPopulatedFilterPipe } from './is-populated-filter/is-populated-filter.directive';
import { ReorderHintComponent } from './reorder-hint/reorder-hint.component';
import { TimepickerComponent } from './timepicker/timepicker.component';
import { ImageCropperFullSizeComponent } from './image-cropper-full-size/image-cropper-full-size.component';
import { CompanyTypeFieldComponent } from './company-type-field/company-type-field.component';

const PUBLIC_API = [
  IconComponent,
  ControlWrapperComponent,
  TooltipDirective,
  TooltipComponent,
  ShowHidePasswordComponent,
  ForgotPasswordComponent,
  ErrorContentComponent,
  ModalTemplateComponent,
  PaginatorComponent,
  DropdownComponent,
  BreadcrumbsComponent,
  ImageCropperDialogComponent,
  TrimOnBlurDirective,
  NotificationsAssignmentComponent,
  AutocompleteComponent,
  IsPopulatedFilterPipe,
  ExportWidgetComponent,
  AlertComponent,
  GroupedAutocompleteComponent,
  SwipeHintComponent,
  ReorderHintComponent,
  CheckListComponent,
  DatepickerComponent,
  TimepickerComponent,
  ImageCropperFullSizeComponent,
  DeleteItemComponent,
  CompanyTypeFieldComponent
];

const PRIVATE_API = [PaginatorTitleComponent, SwipeHintComponent];

@NgModule({
  imports: [
    CommonModule,
    InlineSVGModule,
    HttpClientModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    AngularCropperjsModule,
    NgxMaskModule,
    MatDatepickerModule,
    MatMomentDateModule
  ],
  declarations: [...PUBLIC_API, ...PRIVATE_API],
  exports: [...PUBLIC_API]
})
export class CommonComponentsModule {}
